import createReactComponent from '../createReactComponent';
export default createReactComponent('arrow-ramp-left', 'IconArrowRampLeft', [
  ['path', { d: 'M17 3l0 8.707', key: 'svg-0' }],
  ['path', { d: 'M13 7l4 -4l4 4', key: 'svg-1' }],
  ['path', { d: 'M7 14l-4 -4l4 -4', key: 'svg-2' }],
  ['path', { d: 'M17 21a11 11 0 0 0 -11 -11h-3', key: 'svg-3' }],
]);
